(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  let button = null;
  let placeholder = null;
  let wrapper = null;

  const findHero = () => {
    return document.querySelector('#Hero-hero_jVaWmY') ||
      document.querySelector('[id$="__hero_jVaWmY"]');
  };

  const findShopAll = (root) => {
    if (!root) return null;
    const candidates = root.querySelectorAll('a.button, button.button, a, button');
    return Array.from(candidates).find((el) =>
      (el.textContent || '').trim().toLowerCase() === 'shop all'
    ) || null;
  };

  const restoreDesktop = () => {
    if (button && placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(button, placeholder.nextSibling);
    }
    if (wrapper) {
      wrapper.remove();
      wrapper = null;
    }
  };

  const apply = () => {
    const main = document.querySelector('main[data-template="index"]');
    if (!main) return;

    const hero = findHero();
    if (!hero) return;
    const section = hero.closest('.shopify-section') || hero;

    if (!button || !document.documentElement.contains(button)) {
      button = findShopAll(hero) || findShopAll(section);
      if (!button) return;
      placeholder = document.createComment('ps-shop-all-original-position');
      button.parentNode.insertBefore(placeholder, button);
    }

    if (!mq.matches) {
      restoreDesktop();
      return;
    }

    if (!wrapper || !document.documentElement.contains(wrapper)) {
      wrapper = document.createElement('div');
      wrapper.className = 'ps-mobile-shop-all';
      section.insertAdjacentElement('afterend', wrapper);
    }

    if (button.parentNode !== wrapper) wrapper.appendChild(button);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  mq.addEventListener?.('change', apply);
  document.addEventListener('shopify:section:load', () => setTimeout(apply, 0));
})();
